// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3ziGD","footer":"ChangeClinic_footer__15fiK"};